enum EditStatus {
    PENDING = 'statusPending',
    SUCCESS = 'statusSuccess',
    FAILED = 'statusFailed'
}

export default EditStatus
